import { differenceInDays, parseISO } from "date-fns";
import { Clock } from "lucide-react";

export default function DeadlineBadge({ isoDate }) {
  if (!isoDate) return null;
  try {
    const d = parseISO(isoDate);
    const days = differenceInDays(d, new Date());
    let cls = "moe-chip"; let label;
    if (days < 0)       { cls = "moe-chip moe-chip-pink"; label = `${Math.abs(days)}d overdue`; }
    else if (days === 0){ cls = "moe-chip moe-chip-yolk moe-pulse"; label = "Today"; }
    else if (days <= 7) { cls = "moe-chip moe-chip-yolk moe-pulse"; label = `${days}d left`; }
    else if (days <= 30){ cls = "moe-chip moe-chip-cyan"; label = `${days}d left`; }
    else                { cls = "moe-chip"; label = `${days}d left`; }
    return <span className={cls}><Clock size={12}/> {label}</span>;
  } catch { return null; }
}
